<div class="js-endpoint">
  <div class="js-endpoint__content">
    <div class="row b-row">
      <div class="col-12">
        <div class="form-group">
          <label>JS Tag Type</label>
          <nz-select nzShowSearch nzPlaceHolder="Select JS Tag Type" name="type" [(ngModel)]="tagType"
            (ngModelChange)="onTagTypeChanged($event)">
            <nz-option *ngFor="let tag of jsTagTypes" [nzValue]="tag.id" [nzLabel]="tag.name"></nz-option>
          </nz-select>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>JS Tag</label>
      <div class="textarea-wrapper">
        <nz-input-group [nzSuffix]="copyIcon" class="ant-input-affix-wrapper-textarea-with-copy-btn">
          <textarea nz-input [(ngModel)]="jsTag" placeholder="textarea with copy icon" name="jsTag"
            [disabled]="true"></textarea>
        </nz-input-group>
        <ng-template #copyIcon>
          <span nz-icon class="ant-input-copy-icon" nzTheme="fill" nzType="copy" (click)="linkCopy()"
            [cbContent]="jsTag" ngxClipboard></span>
        </ng-template>
      </div>
    </div>
    <div class="macros-group"
      *ngIf="tagType === 'web' || tagType === 'app' || tagType === 'serverWeb' || tagType === 'serverApp'">
      <div class="col-9">
        <div class="form-group">
          <nz-select nzShowSearch [nzShowArrow]="true" nzPlaceHolder="Select Macros" name="addMacros"
            (ngModelChange)="changeMacros($event)" [(ngModel)]="selectedMacros" nzMode="multiple">
            <nz-option *ngFor="let macros of macrosListJs" [nzValue]="macros.id" [nzLabel]="macros.name">
            </nz-option>
          </nz-select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <button nz-button nzType="default" type="button" (click)="showMacrosList()">
            Macros List
          </button>
        </div>
      </div>
    </div>
  </div>
</div>